import { render, staticRenderFns } from "./OrderProductTitleDetails.vue?vue&type=template&id=37a22d82&"
import script from "./OrderProductTitleDetails.vue?vue&type=script&lang=js&"
export * from "./OrderProductTitleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports